import React, { useState } from 'react';

const MAX_VISIBLE = 3;

const TagList = ({ tags }) => {
    const [expanded, setExpanded] = useState(false);
    const list = tags.map((t) => t.trim()).filter(Boolean);
    const visible = expanded ? list : list.slice(0, MAX_VISIBLE);
    const hiddenCount = list.length - MAX_VISIBLE;

    return (
        <div className="flex flex-wrap items-center gap-2">
            {visible.map((tag, i) => (
                <span
                    key={i}
                    className="inline-block bg-brand-50 dark:bg-brand-700/30 text-brand-600 dark:text-brand-400 rounded-full px-3 py-1 text-xs font-semibold"
                >
                    #{tag}
                </span>
            ))}
            {hiddenCount > 0 && (
                <button
                    type="button"
                    onClick={() => setExpanded(!expanded)}
                    className="tap-target inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold text-gray-500 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                >
                    {expanded ? 'See less' : `+${hiddenCount} more`}
                </button>
            )}
        </div>
    );
};

export default TagList;
